
const DEFAULT_MESSAGE = "Something has gone wrong, please try again.";

export default {
  data() {
    return {
      message: DEFAULT_MESSAGE,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
  },
  mounted() {
    this.$bus.$on('show_modal_alert', this.showAlert);
  },
  beforeDestroy() {
    this.$bus.$off('show_modal_alert', this.showAlert);
  },
  methods: {
    showAlert(message) {
      this.message = message || DEFAULT_MESSAGE;
      this.$modal.show('general_alert');
    },
    hide() {
      this.$modal.hide('general_alert');
    },
  },
};
